import Vue from 'vue'
import { Tabs, Form, Input, Select, Button, Checkbox, Radio, Spin, message, Modal } from 'ant-design-vue'
import SliderVerify from '@/components/slider-verify'

Vue.use(Tabs)
Vue.use(Form)
Vue.use(Input)
Vue.use(Select)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Radio)
Vue.use(Spin)
Vue.use(SliderVerify)
Vue.prototype.$message = message
Vue.prototype.$error = Modal.error
